import uniqueId from 'lodash/uniqueId';
import { useMemo } from "react";

export const useUniqueId = () => useMemo(() => uniqueId(), [])
